import React, { Component } from 'react';
import NavBar from '../../../_components/common/Navbar';
import Settings from '../../../_components/common/SettingsHeader';
import { connect } from 'react-redux';
import { developmentPlanActions, updateRespondents, getRelationList, updateRelationList } from '../../../_actions';
import Aux from '../../../_components/common/Hoc';
import { updateRespondentsData } from './developmentPlanFormData';

import ModalNew from '../../../_components/common/ModalNew';
import './index.css'
import { CommonBreadCrumb } from '../../../_components/common/CommonBreadCrumb';

class DevelopmentPlan extends Component {

	constructor(props) {
		super(props);

		this.state = {
			modal: false,
			editRelationStateForPersonal: false,
			updateStateForPersonal: false,
			developmentPlanData: '',
			updateStateForProfessional: false,
			editRelationStateForProfessional: false,
			addRelation: [],
			developmentPlanId: null
		}
	}

	componentDidMount() {
		this.props.dispatch(developmentPlanActions.getDevelopmentPlan());
		this.props.dispatch(getRelationList.getRelationListHandler())
	}

	toggleModal(showModal) {
		this.setState({
			modal: showModal
		});
	}


	toggleUpdateModalForPersonal(showModal) {

		updateRespondentsData.map(
			(data, i) => {
				this.props.developmentPlanResponse.map(
					(devdata, i) => {
						if (devdata.development_plan_name.toLowerCase() === "personal") {

							this.setState({
								developmentPlanId: devdata.id
							})
							data.value = devdata[data.key];
							data.valid = true;
						}
					}
				)
			})

		this.setState({
			updateStateForPersonal: showModal
		})
	}

	toggleUpdateModalForProfessional(showModal) {

		updateRespondentsData.map(
			(data, i) => {
				this.props.developmentPlanResponse.map(
					(devdata, i) => {
						if (devdata.development_plan_name.toLowerCase() === "professional") {
							this.setState({
								developmentPlanId: devdata.id
							})
							data.value = devdata[data.key];
							data.valid = true;
						}
					}
				)
			})

		this.setState({
			updateStateForProfessional: showModal
		})
	}


	editRelationAction(data) {
		let contId = [];

		for (let i in data.sellerData) {
			if (data.sellerData[i]) {
				for (let j in this.props.relationListResponse) {

					if (this.props.relationListResponse[j].assessor_name === i) {
						contId.push(this.props.relationListResponse[j].id)
					}
				}
			}
		}
		const id = this.state.developmentPlanId;
		const fd = {
			"relations": contId
		}
		this.props.dispatch(updateRelationList.updateRelationListHandler(fd, id))
	}

	getValueForPersonal(relation, plan) {

		for (let i in this.props.developmentPlanResponse) {
			if (this.props.developmentPlanResponse[i].development_plan_name.toLowerCase() === plan) {
				this.setState({
					developmentPlanId: this.props.developmentPlanResponse[i].id
				})
				for (let j in this.props.developmentPlanResponse[i].relations) {

					if (this.props.developmentPlanResponse[i].relations[j].accessor_group__assessor_name === relation.assessor_name) {

						return true
					}
				}
			}
		}
		return false
	}

	toggleEditModalForPersonal = (showModal) => {

		let addRelation = []
		this.props.relationListResponse.map(
			(relation, i) => {

				if (!relation.assessor_group_type) {
					addRelation.push(
						{
							key: relation.assessor_name,
							type: 'checkbox',
							value: this.getValueForPersonal(relation, "personal"),
							valid: true,
							elementConfig: {
								name: relation.assessor_name,
								label: relation.assessor_name,
							},
							validation: {
								required: false,
								message: ""
							}
						}
					)
				}
			}
		)

		this.setState({
			editRelationStateForPersonal: showModal,
			addRelation: addRelation
		})

	}

	toggleEditModalForProfessional(showModal) {
		let addRelation = []
		this.props.relationListResponse.map(
			(relation, i) => {
				if (relation.assessor_group_type) {
					addRelation.push(
						{
							key: relation.assessor_name,
							type: 'checkbox',
							value: this.getValueForPersonal(relation, "professional"),
							valid: true,
							elementConfig: {
								name: relation.assessor_name,
								label: relation.assessor_name,
							},
							validation: {
								required: false,
								message: ""
							}
						}
					)
				}
			}
		)

		this.setState({
			editRelationStateForProfessional: showModal,
			addRelation: addRelation

		})

	}

	toggleEditModal(showModal) {
		this.setState({
			editRelationState: showModal
		})
	}

	toggleEntireUpdateModal(showModal) {
		this.setState({
			updateStateForPersonal: showModal,
			updateStateForProfessional: showModal,
			editRelationStateForPersonal: showModal,
			editRelationStateForProfessional: showModal,
		})
	}

	updateMinRespAction(data) {

		const id = this.state.developmentPlanId;
		const fd = {
			'min_respondent': data.sellerData.min_respondent
		}
		this.props.dispatch(updateRespondents.updateRespondentsHandler(fd, id))
	}


	render() {

		const { developmentPlanLoading, developmentPlanResponse, relationListResponse } = this.props;
		const developmentPlanData = this.state.developmentPlanData === '' ? developmentPlanResponse : this.state.developmentPlanData;




		let buttonDataPropForPersonal = [
			{
				id: 1,
				heading: "Update minimum respondents",
				toggler: this.toggleUpdateModalForPersonal.bind(this),
				togglerModal: this.state.updateStateForPersonal
			},
			{
				id: 2,
				heading: "EDIT RELATIONS",
				toggler: this.toggleEditModalForPersonal.bind(this),
				togglerModal: this.state.editRelationStateForPersonal
			}
		]

		let buttonDataPropForProfessional = [
			{
				id: 1,
				heading: "Update minimum respondents",
				toggler: this.toggleUpdateModalForProfessional.bind(this),
				togglerModal: this.state.updateStateForProfessional
			},
			{
				id: 2,
				heading: "EDIT RELATIONS",
				toggler: this.toggleEditModalForProfessional.bind(this),
				togglerModal: this.state.editRelationStateForProfessional

			}
		]

		return (
			<div>
				<NavBar />

				<div className="container custom-container my-5" >

					<div>
						<CommonBreadCrumb
							data={[
								{
									link: '/admin/app/dashboard',
									name: 'ADMIN'
								}, {
									link: '',
									name: 'DEVELOPMENT PLAN'
								}
							]}
						/>
					</div>

					{
						developmentPlanResponse !== [] &&
						<React.Fragment>
							<div className="bg-green rounded-top position-relative animation-fade-in">
								<p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> personal development plan </p>
								{
									developmentPlanLoading &&
									<i className="fas fa-spinner fa-spin text-white position-absolute spinner-position " ></i>
								}


								<div>
									<Settings
										buttonData={buttonDataPropForPersonal}
										filter={false}

										modal={this.toggleModal.bind(this)}
										showModal={this.state.modal}
									/>
								</div>

								<div className="d-flex flex-row flex-wrap light-grey">
									{
										this.props.developmentPlanResponse !== '' && !developmentPlanLoading &&
										developmentPlanData.map(
											(developmentData, i) => {
												{
													return (
														developmentData.development_plan_name.toLowerCase() === 'personal' &&
														<Aux key={i}>

															<div className="py-3 col-3">
																<strong className="text-uppercase bold"> Min. Respondents </strong>
															</div>
															<div className="py-3 col-9 text-md-left text-center">
																{developmentData.min_respondent}
															</div>

															<div className="py-3 col-3">
																<strong className="text-uppercase bold">Relations</strong>
															</div>

															<div className="col-9 py-3 text-md-left text-center">
																<span className="text-capitalize">
																	{
																		developmentData.relations === [] ? '' :
																			developmentData.relations.map(
																				(relations, i) => {
																					if (developmentData.relations.length === i + 1) {
																						return relations.accessor_group__assessor_name

																					}
																					else {
																						return relations.accessor_group__assessor_name + ', '
																					}
																				}
																			)
																	}
																</span>
															</div>
														</Aux>
													)
												}

											}
										)
									}

									{
										this.state.updateStateForPersonal &&
										<ModalNew
											modalName="UPDATE MINIMUM RESPONDENTS"
											heading="UPDATE MINIMUM RESPONDENTS"
											showModal={this.state.updateStateForPersonal}
											formData={updateRespondentsData}
											action={this.updateMinRespAction.bind(this)}

											toggleEntireModal={this.toggleEntireUpdateModal.bind(this)}

										/>
									}

									{
										this.state.editRelationStateForPersonal &&
										<ModalNew
											modalName="personal development plan"
											heading="Personal Development Plan"
											showModal={this.state.editRelationStateForPersonal}
											formData={this.state.addRelation}
											action={this.editRelationAction.bind(this)}
											toggleEntireModal={this.toggleEntireUpdateModal.bind(this)}
										/>
									}
								</div>
							</div>

							<div className="bg-green rounded-top my-4 position-relative animation-fade-in">
								<p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> professional development plan </p>
								{
									developmentPlanLoading &&
									<i className="fas fa-spinner fa-spin text-white position-absolute spinner-position " ></i>
								}


								<div>
									<Settings
										buttonData={buttonDataPropForProfessional}
										filter={false}

										modal={this.toggleModal.bind(this)}
										showModal={this.state.modal}
									/>
								</div>

								<div className="d-flex flex-row flex-wrap light-grey">
									{
										this.props.developmentPlanResponse !== '' && !developmentPlanLoading &&
										developmentPlanData.map(
											(developmentData, i) => {
												{
													return (
														developmentData.development_plan_name.toLowerCase() === 'professional' &&
														<Aux key={i}>

															<div className="py-3 col-3">
																<strong className="text-uppercase bold"> Min. Respondents </strong>
															</div>
															<div className="py-3 col-9 text-md-left text-center">
																{developmentData.min_respondent}
															</div>

															<div className="py-3 col-3">
																<strong className="text-uppercase bold">Relations</strong>
															</div>

															<div className="col-9 py-3 text-md-left text-center">
																<span className="text-capitalize">
																	{
																		developmentData.relations === [] ? '' :
																			developmentData.relations.map(
																				(relations, i) => {
																					if (developmentData.relations.length === i + 1) {
																						return relations.accessor_group__assessor_name
																					}
																					else {
																						return relations.accessor_group__assessor_name + ', '
																					}
																				}
																			)
																	}
																</span>
															</div>
														</Aux>
													)
												}

											}
										)
									}
									
									{
										this.state.updateStateForProfessional &&
										<ModalNew
											modalName="UPDATE MINIMUM RESPONDENTS"
											heading="UPDATE MINIMUM RESPONDENTS"
											showModal={this.state.updateStateForProfessional}
											formData={updateRespondentsData}
											action={this.updateMinRespAction.bind(this)}
											toggleEntireModal={this.toggleEntireUpdateModal.bind(this)}
										/>
									}
									{
										this.state.editRelationStateForProfessional &&
										<ModalNew
											modalName="professional development plan"
											heading="Professional Development Plan"
											showModal={this.state.editRelationStateForProfessional}
											formData={this.state.addRelation}
											action={this.editRelationAction.bind(this)}
											toggleEntireModal={this.toggleEntireUpdateModal.bind(this)}
										/>
									}
								</div>
							</div>
						</React.Fragment>
					}

					{
						developmentPlanResponse === [] &&
						<p className="h6 text-center">No Data found</p>
					}
				</div>
			</div>
		)
	};
}

function mapStateToProps(state) {

	const { developmentPlanLoading, } = state.developmentPlan;
	const developmentPlanError = state.developmentPlan.error;
	const developmentPlanResponse = (!developmentPlanLoading && !developmentPlanError) ? state.developmentPlan.data.data.results : '';
	const developmentPlanResponseCode = (!developmentPlanLoading && !developmentPlanError) ? state.developmentPlan.data.status : '';

	const { RelationListLoading, } = state.relationList;
	const relationListError = state.relationList.error;
	const relationListResponse = (!RelationListLoading && !relationListError) ? state.relationList.data.data.results : '';
	const relationListResponseCode = (!RelationListLoading && !relationListError) ? state.relationList.data.status : '';
	return {
		developmentPlanLoading,
		developmentPlanResponse,
		developmentPlanResponseCode,

		relationListResponse,
		relationListResponseCode,
	};
}

export default connect(mapStateToProps)(DevelopmentPlan);


// WEBPACK FOOTER //
// ./src/_pages/Admin/DevelopmentPlan/index.jsx